import LinkListPresenter from "./LinkList/LinkListPresenter";

export const LinkList = {
    List: LinkListPresenter,
}

export default LinkList;